export default function RTKDetails() {
    return (
      <div>

<div className="rtk-bg bg-image">


<div className="gap-spacer"></div>
<div className="page-title top-cap-outlines">
<h2>Right To Know</h2>
</div>

{/*End Large Image Space*/}
{/*Start Main Content*/}
<div className="content-fluid">

<div className="mb-960-center-container mid-side-outlines">
    {/*Full Width Element*/}
    <div className="mb-960-col-50p">
        <div className="left-right-padding-1em">
            <br/>
            <h4>RTK Officer</h4>
            <b>Sue Knott</b> <p>
            <a href="https://maps.app.goo.gl/RjUcQgXYQvFVtETj8">
                <i className="fa-solid fa-location-pin"></i>&nbsp;35 Union Street Morrisville, PA 19067</a><br/>
            <a href="tel:2152958181"><i className="fa-solid fa-phone"></i>&nbsp;215-295-8181</a><br/>
            <a href="tel:2157363760"><i className="fa-solid fa-fax"></i>&nbsp;215-736-3760<br/></a>
            <a href="mailto:sknott@morrisvilleboro.org"><i className="fa-solid fa-envelope"></i>&nbsp;sknott@morrisvilleboro.org</a></p>

            <h4>RTK Information</h4>
            <p>For regulations, policies, and procedures related to the “Right To Know Law” <a href="http://www.openrecords.pa.gov">please click here to go to the PA OOR website: http://www.openrecords.pa.gov&nbsp;<i className="fa-solid fa-arrow-up-right-from-square"></i></a></p>
            <h4>RTK Form</h4>
            <p><a href="../docs/rtk/PA-RTKRequestForm.pdf"><i className="fa-solid fa-file-pdf"></i>&nbsp;Click here for a copy of the PA State RTK form that can be used to submit RTK requests to Morrisville Borough</a></p>
        </div>
    </div>
    <div className="mb-960-col-50p">
        <div className="left-right-padding-1em">
            <br/>
            <h4>Submitting an RTK Request</h4>
            Completed RTK forms may be submitted in the following ways:
            <ul>
                <li>Submitted in person at Morrisville Borough Hall<br/> <a href="https://maps.app.goo.gl/RjUcQgXYQvFVtETj8">
                        <i className="fa-solid fa-location-pin"></i>&nbsp;35 Union Street Morrisville, PA 19067</a>, between the hours of 8:00 a.m. and 4:30 p.m. on normal work days.</li>
                <li> Mailed to Morrisville Borough Hall at <a href="https://maps.app.goo.gl/RjUcQgXYQvFVtETj8">
                        <i className="fa-solid fa-location-pin"></i>&nbsp;35 Union Street Morrisville, PA 19067</a></li>
                <li> E-mailed to the Open Records Officer, Sue Knott, at <a href="mailto:sknott@morrisvilleboro.org"><i className="fa-solid fa-envelope"></i>&nbsp;sknott@morrisvilleboro.org</a> with the subject of the e-mail reading: Open Records Request</li>
                <li> Submitted via Fax: <a href="tel:2157363760"><i className="fa-solid fa-fax"></i>&nbsp;215-736-3760<br/></a></li>
            </ul>

            <h4>Related Documents</h4>
            <table id="filetable">
                <tr>
                    <th>File Name</th>
                    <th>Date Posted</th>

                </tr>
                {/*Start File*/}
                <tr>
                    <td><a href="../docs/rtk/PA-RTKRequestForm.pdf">
                            <i className="fa-solid fa-file-pdf fa-xl"></i>&nbsp;
                            Right-To-Know Request Form</a></td>
                    <td>09/17/2024</td>
                    {/*End File*/}
                </tr>
            </table>
        </div>
    </div>
</div>



<div className="page-footer bottom-cap-outlines">&nbsp;</div>
<div className="gap-spacer"></div><div className="gap-spacer"></div><div className="gap-spacer"></div><div className="gap-spacer"></div><div className="gap-spacer"></div><div className="gap-spacer"></div>

</div></div>


      </div>
    )
}